module.exports = __webpack_public_path__ + "img/news_2.9d816adb.jpg";